import { Formatter } from '@cgn/framework-ui-components/v1';
import React from 'react';
import PropTypes from 'prop-types';

export const ERRORE_INVIO_QUESITO = "Errore nell'invio del messaggio";

export const ASSISTENZA_NON_SUBITO_DISPONIBILE = "Per questo servizio l'assistenza CGN ti aiuterà al più presto.";

export const INFO_CAMPI_ADDIZIONALI = 'Per ricevere una risposta precisa ed immediata forniscici ulteriori informazioni.';

export const UPLOADING_FILE = 'Upload allegato in corso...';
export const UPLOAD_FILE_ERROR = "Errore nel caricamento dell'allegato";

export const MessagioErroreInvioQuesito = () => (
  <span>
    C&apos;è stato un errore nell&apos;invio del quesito.
    <br />
    Per favore riprova più tardi.
  </span>
);

export const MessagioGestioneInTempoNonDefinito = () => (
  <span>
    A breve un nostro Assistente prenderà in carico la tua richiesta.
    <br />
    Riceverai una notifica non appena la risposta sarà disponibile.
  </span>
);

export const MessagioGestioneInTempoDefinito = ({ tempoAttesaStimato }) => (
  <span>
    Riceverai un messaggio entro le <Formatter valore={tempoAttesaStimato} tipo="hour" />{'\u00A0'}
    del <Formatter valore={tempoAttesaStimato} tipo="date" />
  </span>
);

MessagioGestioneInTempoDefinito.propTypes = {
  tempoAttesaStimato: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]).isRequired,
};
